import React, { useMemo } from 'react';
import styled from 'styled-components';

const Frame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  display: block;
  background: #000;
`;

const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #111;
  color: #666;
  font-size: 14px;
  font-weight: 600;
`;

/**
 * Converts a regular YouTube URL to its embed equivalent.
 * Passes through any other URL unchanged.
 */
function toEmbedUrl(rawUrl) {
  try {
    const parsed = new URL(rawUrl);

    // https://www.youtube.com/watch?v=VIDEO_ID
    if (
      (parsed.hostname === 'www.youtube.com' || parsed.hostname === 'youtube.com') &&
      parsed.searchParams.get('v')
    ) {
      const videoId = parsed.searchParams.get('v');
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`;
    }

    // https://youtu.be/VIDEO_ID
    if (parsed.hostname === 'youtu.be') {
      const videoId = parsed.pathname.slice(1);
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`;
    }
  } catch {
    // fall through — return as-is
  }
  return rawUrl;
}

/**
 * Renders a URL (website, YouTube video, etc.) inside a full-size iframe.
 * YouTube watch URLs are automatically converted to embed URLs.
 */
const UrlWidgetRenderer = ({ url }) => {
  const embedUrl = useMemo(() => (url ? toEmbedUrl(url) : ''), [url]);

  if (!embedUrl) {
    return <Placeholder>URL não configurado</Placeholder>;
  }

  return (
    <Frame
      src={embedUrl}
      title="URL Widget"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      allowFullScreen
      sandbox="allow-scripts allow-same-origin allow-presentation allow-forms allow-popups"
    />
  );
};

export default UrlWidgetRenderer;
